function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 55.857,
  cy: 87.001,
  fill: "#FFD747",
  r: 19.057
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M101.879 67.506L60.609 95.41c-3.959 2.677-9.355 1.634-12.031-2.324L25.525 58.994a2.167 2.167 0 013.59-2.427L52.166 90.66a4.337 4.337 0 006.015 1.163L97.658 65.13 74.606 31.037a2.167 2.167 0 013.589-2.427l24.265 35.888c.67.99.41 2.338-.581 3.008z",
  fill: "#073331"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M66.847 38.898L34.548 60.737a6.506 6.506 0 01-9.023-1.744 6.506 6.506 0 011.743-9.023l32.3-21.839c.99-.67 2.337-.41 3.007.581l4.853 7.178c.67.99.41 2.338-.581 3.008zM29.695 53.559a2.167 2.167 0 002.426 3.589l30.505-20.626-2.426-3.589L29.695 53.56z",
  fill: "#073331"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M77.614 31.618l-10.767 7.28a2.167 2.167 0 01-2.426-3.589l10.766-7.28a2.167 2.167 0 012.427 3.59zM92.173 53.15l-10.767 7.28a6.506 6.506 0 01-9.023-1.743 6.506 6.506 0 011.744-9.023l10.766-7.28a2.167 2.167 0 012.427 3.589l-10.767 7.28a2.172 2.172 0 00-.58 3.007 2.172 2.172 0 003.007.581l10.766-7.28a2.167 2.167 0 012.427 3.59z",
  fill: "#073331"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2 57.999l12.188.187",
  stroke: "#f59bbb",
  strokeWidth: 3.714,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.971 38.115l12.188 5.159",
  stroke: "#073331",
  strokeWidth: 3.714,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M26.857 24.857l2.246 10.13",
  stroke: "#FFD747",
  strokeWidth: 3.714,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIconCheap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 116,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgIconCheap;